import { Typography } from "@mui/material"

type Props = {}

const SendFriendRequestTitle = (props: Props) => {
  return <Typography variant="h5">Send Friend Request</Typography>
}

export default SendFriendRequestTitle
